import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link, useLocation } from 'react-router-dom';
import { siteData } from '../config/config';
import { leftPanelLinks, rightPanelLinks } from '../data/localData';
import { BsSearch } from 'react-icons/bs';
import { IoIosArrowForward } from 'react-icons/io';
import { useDispatch } from 'react-redux';
import { updateModal } from '../store/slices/modalSlice';
import { Accordion } from 'react-bootstrap';

function Header() {
  const [showHeader, setShowHeader] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();
  const dispatch = useDispatch();
  const [handleOffCanvas, setHandleOffCanvas] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 72) {
        // Scroll down and past 50px
        setShowHeader(false);
      } else {
        // Scroll up
        setShowHeader(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  const handleRedirect = (link) => {
    return link.toLowerCase().replace("-", "~").replace(/\s+/g, "-")
  }

  return (
    <div className='web-header'>
      <Navbar
        expand={"lg"}
        fixed="top"
        // className={`bg-compo-color py-0 ${showHeader ? 'visible' : 'hidden'}`}
        className={`bg-compo-color py-0 visible`}
        style={{
          transition: 'transform 0.3s ease-in-out',
          // transform: showHeader ? 'translateY(0)' : 'translateY(-100%)',
          transform: 'translateY(0)',
        }}
      >
        <Container>
          <Navbar.Brand className='d-lg-none'>
            <div className='logo-holder-nav pe-4'>
              <Link to={'/'} className=''>
                <img src={siteData.logoWithText} alt="" />
              </Link>
            </div>
          </Navbar.Brand>
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-lg`}
            aria-labelledby={`offcanvasNavbarLabel-expand-lg`}
            placement="end"
            show={handleOffCanvas} onHide={() => setHandleOffCanvas(false)}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-lg`}>
                {siteData?.logoText}
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-between flex-grow-1 align-items-center custom-header-links-head">
                <Link
                  to={"/"}
                  className='logo-holder d-none d-lg-block'
                  onClick={() => setHandleOffCanvas(false)}
                >
                  <img src={siteData?.logo} alt="" />
                </Link>
                <div className='d-none d-lg-flex justify-content-lg-center gap-xl-4 flex-1 custom-header-links main-menu'>
                  {
                    leftPanelLinks.map((item, index) => (
                      <>
                        <div
                          key={index}
                          to={item?.value}
                          className={`main-menu-item d-grid ${(location.pathname === item?.value) ? "fw-semibold active-text" : ""}`}
                          onClick={() => setHandleOffCanvas(false)}
                        >
                          <Link
                            to={item?.value}
                            className={`main-menu-item-peta flex-between-align gap-1 ${(location.pathname === item?.value) ? "fw-semibold active-text" : ""}`}
                          >
                            <span>
                              {item?.label}
                            </span>
                            {
                              item?.data?.length > 0 &&
                              <IoIosArrowForward className='main-menu-icon' />
                            }
                          </Link>
                          {
                            item?.data?.length > 0 &&
                            <>
                              <div className='sub-menu'>
                                {
                                  item?.data.map((subItem, subIndex) => {
                                    return (
                                      <div key={subIndex} className='sub-menu-item'>
                                        <Link to={`${item?.value}/${handleRedirect(subItem?.label)}`} className='sub-menu-item-peta flex-between-align py-2 px-3'>
                                          <span>{subItem.label}</span>
                                          {
                                            subItem?.data?.length > 0 &&
                                            <IoIosArrowForward className='main-menu-icon' />
                                          }
                                        </Link>
                                        <div className='peta-menu'>
                                          {
                                            subItem?.data?.length > 0 &&
                                            subItem?.data.map((petaItem, petaIndex) => {
                                              return (
                                                <div key={petaIndex} className='peta-menu-item'>
                                                  <Link
                                                    to={`${item?.value}/${handleRedirect(subItem?.label)}/${handleRedirect(petaItem?.label)}`}
                                                    className='peta-menu-item-peta flex-between-align px-3 py-2'>
                                                    <span>{petaItem.label}</span>
                                                    {
                                                      petaItem?.data?.length > 0 &&
                                                      <IoIosArrowForward className='main-menu-icon' />
                                                    }
                                                  </Link>
                                                  {
                                                    petaItem?.data?.length > 0 &&
                                                    <div className='temp-menu'>
                                                      {
                                                        petaItem?.data.map((tempItem, tempIndex) => {
                                                          return (
                                                            <Link
                                                              to={`${item?.value}/${handleRedirect(subItem?.label)}/${handleRedirect(petaItem?.label)}#${handleRedirect(tempItem?.label)}`}
                                                              key={tempIndex} className='temp-menu-item flex-between-align px-3 py-2'>
                                                              {tempItem.label}
                                                            </Link>
                                                          )
                                                        })
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              )
                                            })
                                          }
                                        </div>
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            </>
                          }
                        </div>

                      </>
                    ))
                  }
                </div>
                <div className='d-grid d-lg-none gap-4 gap-xl-4 flex-1 custom-header-links main-menu'>
                  {
                    leftPanelLinks.map((item, index) => {
                      return (
                        <>
                          {
                            !item?.data?.length > 0 ?
                              <Link
                                to={item?.value}
                                className={`main-menu-item-peta flex-between-align gap-1 ${(location.pathname === item?.value) ? "fw-semibold active-text" : ""}`}
                                onClick={() => setHandleOffCanvas(false)}
                              >
                                <span>
                                  {item?.label}
                                </span>
                              </Link>
                              :
                              <Accordion className='custom-main-drop'>
                                <Accordion.Item eventKey={index}>
                                  <Accordion.Header className=''>{item?.label}</Accordion.Header>
                                  <Accordion.Body className='px-1 pb-1'>
                                    <Accordion className='custom-main-drop d-grid gap-2'>
                                      {
                                        item?.data?.length > 0 &&
                                        item?.data.map((subItem, subIndex) => {
                                          return (
                                            <Accordion.Item eventKey={subIndex}>
                                              <Accordion.Header className=''>{subItem?.label}</Accordion.Header>
                                              <Accordion.Body className='px-1 pb-1'>
                                                <Accordion className='custom-main-drop d-grid gap-2'>
                                                  {
                                                    subItem?.data?.length > 0 &&
                                                    subItem?.data.map((petaItem, petaIndex) => {
                                                      return (
                                                        <Accordion.Item eventKey={petaIndex}>
                                                          <Accordion.Header className=''>{petaItem?.label}</Accordion.Header>
                                                          <Accordion.Body className='px-1'>
                                                            <div className='custom-main-drop d-grid gap-2'>
                                                              {
                                                                petaItem?.data?.length > 0 &&
                                                                petaItem?.data.map((tempItem, tempIndex) => {
                                                                  return (
                                                                    <Link
                                                                      // to={miniItem?.value}
                                                                      to={`${item?.value}/${handleRedirect(subItem?.label)}/${handleRedirect(petaItem?.label)}#${handleRedirect(tempItem?.label)}`}
                                                                      className={`main-menu-item-peta flex-between-align gap-1 ${(location.pathname === tempItem?.value) ? "fw-semibold active-text" : ""}`}
                                                                      key={tempIndex}
                                                                      onClick={() => setHandleOffCanvas(false)}
                                                                    >
                                                                      <span>
                                                                        {tempItem?.label}
                                                                      </span>
                                                                    </Link>
                                                                  )
                                                                })
                                                              }
                                                            </div>
                                                          </Accordion.Body>
                                                        </Accordion.Item>
                                                      )
                                                    })
                                                  }
                                                </Accordion>
                                              </Accordion.Body>
                                            </Accordion.Item>
                                          )
                                        })
                                      }
                                    </Accordion>
                                  </Accordion.Body>
                                </Accordion.Item>
                              </Accordion>
                          }
                        </>
                      )
                    })
                  }
                </div>
                <Link className='content-btn fw-semibold text-uppercase half-border-rad py-2 bg-temp text-light fs-14'
                  onClick={() => dispatch(updateModal(true))}>
                  get a quote
                </Link>
                {/* <div className='d-none d-lg-flex header-search-bar flex-center-align gap-2'>
                  <label htmlFor="search"><BsSearch className='fs-18 mb-1 pointer' /></label>
                  <input type="text" name='search' id='search' placeholder='Search' className='clear-input' />
                </div> */}
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
          <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-lg`} onClick={() => setHandleOffCanvas(true)} />
        </Container>
      </Navbar>
    </div>
  );
}

export default Header;